import { useState } from 'react';

export const useFormState = (initialFormValue = {}) => {
  const [formValue, setFormValue] = useState(initialFormValue);

  const formChangeHandler = ({ target = {} }) => {
    const { name, value, type, valueAsNumber } = target;

    if (!name) {
      return;
    }

    let actualValue = value;

    if (type === 'date') {
      actualValue =
        !valueAsNumber || Number.isNaN(valueAsNumber) ? null : valueAsNumber;
    }

    setFormValue((currentData) => ({
      ...currentData,
      [name]: actualValue,
    }));
  };

  return {
    formValue,
    setFormValue,
    formChangeHandler,
  };
};
